<template>
    <div class="pvPcsDetails">
        <div class="left">
            <div :class="{'chartBox': true, 'expendChart': isChartExtend }">
                <div class="topContent" v-if="isChartExtend">
                    <div class="leftbox">
                        <div class="item" :class="{ active: active == 0 }" @click="tabChange(0)">
                            <span>{{ $t('bms.cluster.daily') }}</span>
                            <div class="triangle" v-if="active == 0"></div>
                        </div>
                        <div class="item" :class="{ active: active == 1 }" @click="tabChange(1)">
                            <span>{{  $t('ems.power.weekly') }}</span>
                            <div class="triangle" v-if="active == 1"></div>
                        </div>
                        <div class="item" :class="{ active: active == 2 }" @click="tabChange(2)">
                            <span>{{ $t('bms.cluster.month') }}</span>
                            <div class="triangle" v-if="active == 2"></div>
                        </div>
                    </div>
                    <div class="rightbox">
                        <el-form
                                class="table_header tableSearchForm"
                                :inline="true"
                                size="small"
                                label-width="80px"
                                label-position="left"
                        >
                            <el-form-item style="width: 400px">
                                <el-date-picker
                                        v-model="time"
                                        :type="dateType"
                                        :range-separator="$t('bms.cluster.to')"
                                        :start-placeholder="$t('bms.cluster.StartDate')"
                                        :end-placeholder="$t('bms.cluster.EndDate')"
                                        style="width: 100%"
                                        popper-class="dateDown"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <div class="btn btn_active" @click="search">
                                <i class="iconfont icon-sousuo"></i><span>{{ $t('bms.cluster.search') }}</span>
                            </div>
                        </el-form>
                    </div>
                </div>
                <div class="chart boxBg1" ref="powerChart" style="position: relative" v-loading="chartloading" element-loading-text="Loading"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(42, 43, 44, 0.6)"></div>
                <div class="chart_expend" @click="chartExtend"><i class="el-icon-full-screen"></i></div>
            </div>
        </div>
        <div style="width: 20px; height: 100%"></div>
        <div class="right">
            <div class="pcsbox">
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.current')" placement="top-start">
                            <span>{{$t('ems.current')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.current | numberFormat1 }}<span>A</span></div>
                </div>
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.voltage')" placement="top-start">
                            <span>{{$t('ems.voltage')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.voltage | numberFormat1 }}<span>V</span></div>
                </div>
            </div>
            <div class="pcsbox">
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.Realtimepower')" placement="top-start">
                            <span>{{$t('ems.Realtimepower')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.power | numberFormat2 }}<span>kW</span></div>
                </div>
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('bms.lineState')" placement="top-start">
                            <span>{{$t('bms.lineState')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.onLine == 1 ? $t('bms.online') : $t('bms.offline') }}<span></span></div>
                </div>
            </div>
            <div class="pcsbox">
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.pv.DailyPowerGeneration')" placement="top-start">
                            <span>{{$t('ems.pv.DailyPowerGeneration')}} </span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.powerT | numberFormat0 }}<span>kWh</span></div>
                </div>
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.pv.MonthPowerGeneration')" placement="top-start">
                            <span>{{$t('ems.pv.MonthPowerGeneration')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.powerM | numberFormat0 }}<span>kWh</span></div>
                </div>
            </div>
            <div class="pcsbox">
                <div class="box boxBg">
                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">
                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.pv.YearPowerGeneration')" placement="top-start">
                            <span>{{$t('ems.pv.YearPowerGeneration')}}</span>
                        </el-tooltip>
                    </div>
                    <div class="value">{{ pvData.powerY | numberFormat0 }}<span>kWh</span></div>
                </div>
<!--                <div class="box boxBg">-->
<!--                    <div class="title" v-bind:style="{ fontSize: language === 'en' ? '15px':'' }">-->
<!--                        <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.power.BMSChargingCapacity')" placement="top-start">-->
<!--                            <span>{{ $t('ems.power.BMSChargingCapacity') }}</span>-->
<!--                        </el-tooltip>-->
<!--                    </div>-->
<!--                    <div class="value">{{ pvData.TAG_75EA | nullFormat }}<span>kWh</span></div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { getPcs, chartPcs, getPvPcs } from "@/api/pcs";
    import { setStore, getStore } from "@/utils/store";
    import { mapGetters } from "vuex";
    import moment from "moment";
    import i18n from "@/lang";
    import {themeOptions} from '@/theme';

    export default {
        props: ["activeItem"],
        name: "pvPcsDetails",
        data(){
            return {
                groupNo: getStore({name: "siteNo"})||"",
                powerChart: null,
                pvData: {},
                chartloading: false,
                timer: null,
                collectTime: '',
                isChartExtend: false,
                active: 0,
                time: [moment().startOf('day'), moment()],
                dateType: 'daterange',

            }
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
        },
        computed: {
            topic(){
                return "/"+ this.wz +"/"+this.groupNo+"/CN001/"+ this.activeItem.name;
            },
            ...mapGetters(["language", "systemSet", "theme"]),
        },
        methods: {
            loadTab(){
                // this.loading = true;
                if(this.activeTab !== ""){
                    window.mqttClient.unsubscribe(this.topic);
                }
                this.pvData = {};
                this.httpInit();
                setTimeout(() => {
                    if (this.isChartExtend == true) {
                        this.chartExtend();
                    } else {
                        this.renderChart(0, true);
                    }
                    this.fresh();
                }, 300)
                this.handleMqtt();
            },
            fresh(){
                if(this.timer){
                    clearInterval(this.timer);
                }
                this.timer = setInterval(() => {
                    this.renderChart(this.activeChart, false)
                }, 10000)
            },
            chartExtend(){
                if(this.chartloading){
                    this.$message.error("请等待数据加载完成");
                    return false;
                }
                this.isChartExtend = !this.isChartExtend;
                clearInterval(this.timer);
                if(this.isChartExtend){
                    this.powerChart.clear();
                    setTimeout(() => {
                        this.powerChart.resize();
                        this.renderExtendChart();
                    }, 600)
                }else{
                    this.powerChart.clear();
                    setTimeout(() => {
                        this.powerChart.resize();
                        this.renderChart(0, true);
                        this.fresh();
                    }, 600)
                }
            },
            search(){
                if(this.chartloading) return;
                this.renderExtendChart();
            },
            tabChange(index){
                this.active = index;
                if(index == 0) {
                    this.dateType = "daterange";
                    this.time =  [moment().startOf('day'), moment()];
                }
                if(index == 1) {
                    this.dateType = "daterange";
                    this.time =  [moment().subtract(7, 'd'), moment()];
                }
                if(index == 2) {
                    this.dateType = "monthrange";
                    this.time =  [moment().subtract(1, 'M'), moment()];
                }
                this.renderExtendChart();
            },
            renderExtendChart(){
                if (!this.$refs.powerChart) {
                    return;
                }
                if(this.active == 0){
                    const diff = moment( this.time[1]).diff(moment(this.time[0]), 'days');
                    if(diff > 7){
                        this.$message.warning(i18n.t("ems.power.chartsMessage"));
                        return;
                    }
                }else if(this.active === 1){
                    const diff = moment( this.time[1]).diff(moment(this.time[0]), 'days');
                    if(diff > 30){
                        this.$message.warning(i18n.t("ems.power.chartsMessage1"));
                        return;
                    }
                }else{
                    const diff = moment( this.time[1]).diff(moment(this.time[0]), 'months');
                    if(diff > 3){
                        this.$message.warning(i18n.t("ems.power.chartsMessage2"));
                        return;
                    }
                }

                this.powerChart = this.$echarts.init(this.$refs.powerChart);
                const temp = { ... this.activeItem };
                this.chartloading = true;
                chartPcs(temp.SN, this.active, this.time[0].valueOf(), this.time[1].valueOf()).then(res => {
                    if(!this.isChartExtend) return false;
                    this.chartloading = false;
                    const powerData = res.data.data['0'];
                    const color = themeOptions[this.theme].title1;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'cross',
                                animation: false,
                                label: {
                                    backgroundColor: '#505765'
                                }
                            }
                        },
                        grid: {
                            top: '18%',
                            left: '5%',
                            right: '5%',
                            bottom: '10%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.power.TotalPower")],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '12%',
                            selected: {
                                'SOC': false
                            }
                        },
                        color: ['#2b8a5c', '#a14251', '#44cdea', '#eb9137'],
                        xAxis: [
                            {
                                type: 'category',
                                data: powerData.map(i => { return i.collectTime.replace(' ', '\n');}),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                axisTick: {
                                    alignWithLabel: true
                                },
                                boundaryGap: false,
                                splitLine: {
                                    show: false
                                }
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.power.PowerkW"),
                                type: 'value',
                                // min: min,
                                // max: max,
                                axisLabel: {
                                    formatter: '{value}',
                                    color,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                        ],
                        dataZoom: [
                            {
                                type: 'inside',
                                start: 0,
                                end: 100,
                            },
                            {
                                start: 0,
                                end: 100,
                                backgroundColor: 'rgba(81,81,81,0.25)',
                                borderColor: '#666666',
                                dataBackground: {areaStyle:  {color: '#0acfe6'}},
                            }
                        ],
                        series: [
                            {
                                name: i18n.t("ems.power.TotalPower"),
                                type: 'line',
                                smooth: true,
                                data: powerData.map(i => +i.value),
                            },
                        ]
                    };
                    this.powerChart.setOption(option);
                }).catch(err => {
                    this.chartloading =false;
                    console.log(err);
                });
            },
            renderChart(type, isShowLoad = false){
                if (!this.$refs.powerChart) {
                    return;
                }
                if(!this.powerChart){
                    this.powerChart = this.$echarts.init(this.$refs.powerChart);
                }
                const temp = {...this.activeItem};
                // console.log(this.pcsTotalList);
                this.activeChart = type;
                if(isShowLoad) { this.chartloading =true; }
                this.time = [moment().startOf('day'), moment()];
                chartPcs(temp.SN, type, this.time[0].valueOf(), this.time[1].valueOf()).then(res => {
                    if(this.isChartExtend) return false;
                    this.chartloading =false;
                    const powerData = res.data.data['0'];
                    // const SOCData = res.data.data['1'];
                    const color = themeOptions[this.theme].title1;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.power.TotalPower")],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                        },
                        color: ['#2b8a5c', '#a14251', '#44cdea', '#eb9137'],
                        xAxis: [
                            {
                                type: 'category',
                                data: powerData.map(i => { return i.collectTime.substring(10, i.collectTime.length)}),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                axisTick: {
                                    alignWithLabel: true
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.power.PowerkW"),
                                type: 'value',
                                // interval: (max/5).toFixed(1),
                                splitNumber: 6,
                                axisLabel: {
                                    formatter: '{value}',
                                    color,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                        ],
                        series: [
                            {
                                name: i18n.t("ems.power.TotalPower"),
                                type: 'line',
                                smooth: true,
                                data: powerData.map(i => +i.value),
                            },
                        ]
                    };
                    this.powerChart.setOption(option);
                }).catch(err => {
                    this.chartloading =false;
                    console.log(err);
                });
            },
            httpInit(){
                getPvPcs(this.activeItem.SN).then(res =>  {
                    console.log(res);
                    if(res && res.data && res.data.data){
                        const temp = res.data.data;
                        const d = temp.split(',');
                        // [电压V],[电流A],[功率kW],[当日发电量kWh],[当月发电量kWh],[当年发电量kwh],[在离线标记],[采集时间]
                        this.pvData = {
                            voltage: d[0],
                            current: d[1],
                            power: d[2],
                            powerT: d[3],
                            powerM: d[4],
                            powerY: d[5],
                            onLine: d[6],
                            collectTime: d[7]
                        }
                        this.$parent.showCollectTime(this.pvData.collectTime);
                    }

                })
            },
            handleMqtt(){
                window.mqttClient.subscribe(this.topic, (error) => {
                    if (!error) {
                        console.log("Gateway service MQTT " + this.topic +"订阅成功");
                    } else {
                        console.log("MQTT 订阅失败");
                    }
                });
                window.mqttCallBack[this.topic] = (message) => {
                    const temp = JSON.parse(message) || {};
                    this.pvData = temp;
                    if(temp.i === "p" && temp.d ){
                        const d = temp.d.split(',');
                        // [电压V],[电流A],[功率kW],[当日发电量kWh],[当月发电量kWh],[当年发电量kwh],[在离线标记],[采集时间]
                        this.pvData = {
                            voltage: d[0],
                            current: d[1],
                            power: d[2],
                            powerT: d[3],
                            powerM: d[4],
                            powerY: d[5],
                            onLine: d[6],
                            collectTime: d[7]
                        }
                        this.$parent.showCollectTime(this.pvData.collectTime);
                        console.log(this.pvData)
                    }
                };
            },
            unMqtt(){
                if(this.activeItem ){
                    window.mqttClient.unsubscribe(this.topic);

                    console.log("Gateway service MQTT " + this.topic +"取消订阅");

                }
            },
            isShowInfo(){
                const userinfo = getStore({name: "userInfo"}) || { };
                return userinfo.detail && userinfo.detail.cellInfo === 1  && userinfo.detail.batteryAnalysis === 1 ;
            },
        },
        destroyed() {
            if(this.activeTab !== ""){
                window.mqttClient.unsubscribe(this.topic);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/site";
    @import "@/styles/common";
    .pvPcsDetails{
        width: 100%;
        height: 100%;
        display: flex;
        .left{
            width: 880px;
            height: 100%;
            position: relative;
            .chartBox{
                position: absolute;
                left: 0;
                top: 0;
                height: 714px;
                width: 880px;
                transition: width 0.5s cubic-bezier(0, 0.5, 0.5, 1), height 0.5s cubic-bezier(0, 0.5, 0.5, 1);
                .topContent {
                    position: absolute;
                    left: 0;
                    top: 20px;
                    height: 70px;
                    border-bottom: 1px dashed $font_bright_blue;
                    z-index: 10001;
                    width: 100%;
                    .leftbox {
                        display: flex;
                        position: absolute;
                        top: 20px;
                        left: 20px;
                        .item {
                            width: 68px;
                            height: 30px;
                            color: var(--font128);
                            border: 1px solid var(--font128);
                            text-align: center;
                            line-height: 30px;
                            margin-right: 15px;
                            font-size: 14px;
                            cursor: pointer;
                            position: relative;
                            .triangle {
                                width: 0;
                                height: 0;
                                border: 10px solid transparent;
                                border-bottom: 16px solid $font_bright_blue;
                                position: absolute;
                                top: 22px;
                                left: 24px;
                            }
                        }
                        .active {
                            color: $font_bright_blue;
                            border-color: $font_bright_blue;
                        }
                    }
                    .rightbox {
                        position: absolute;
                        top: 20px;
                        right: 80px;
                        .btn {
                            display: inline-block;
                            height: 28px;
                            width: 80px;
                            color: $_191_191_191;
                            border: $_191_191_191 solid 2px;
                            margin-right: 20px;
                            font-size: 15px;
                            cursor: pointer;
                            transition: all 300ms linear;
                            line-height: 26px;
                            text-align: center;
                            i {
                                margin-right: 5px;
                                font-size: 18px;
                            }
                            span {
                                margin-top: -2px;
                            }
                        }
                        .btn_active {
                            border: $font_bright_blue_title solid 2px;
                            color: $font_bright_blue_title;
                        }
                    }
                }
                .chart{
                    height: 100%;
                    margin-top: 20px;
                }
                .chart_expend{
                    position: absolute;
                    z-index: 10002;
                    right: 0;
                    top: 20px;
                    cursor: pointer;
                    i{
                        margin: 12px;
                        font-size: 24px;
                        color: #9ebae2;
                        font-weight: bold;
                    }
                }
            }
            .expendChart{
                height: 714px;
                width: 1482px;
            }

            .realData{
                height: 180px;
                margin-top: 382px;
            }
            .battery{
                height: 160px;
                margin-top: 10px;
            }

            .chart_choose {
                position: absolute;
                right: 170px;
                top: 38px;
                display: flex;
                .chart_choose_box{
                    border: $_191_191_191 solid 1px;
                    width: 60px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    color: $_191_191_191;
                    margin-right: 10px;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                }
                .chart_choose_box_active{
                    border: $_109_162_238 solid 1px;
                    color: $_109_162_238;
                }
            }
            .pcs_table{
                width: 100%;
                height: 100%;
                border-spacing: 0;
                border-color: transparent;
                tr{
                }
                td{
                    // line-height: 28px;
                    color: $font_bright_blue_title;
                    text-align: center;
                    border-right: $_89_89_89 solid 1px;
                    border-bottom: rgb(67, 67, 67) solid 1px;
                    font-size: 16px;
                    min-width: 90px;
                    .title{
                        box-sizing: border-box;
                    }
                    .unit{
                        font-size: 12px;
                        // padding-left: 4px;
                        box-sizing: border-box;
                    }
                }
                tr:nth-child(odd){
                    td{
                        background-color: var(--table_odd);
                    }
                }
                tr:nth-child(even){
                    td{
                        background-color: var(--font13);
                    }
                }
                &>tr:first-child{
                    height: 50px;
                    td {
                        font-size: 18px;
                        color: $_191_191_191;
                        background-color: var(--table_header);
                    }
                }

                tr{
                    td:last-child{
                        border-right: transparent solid 1px;
                    }
                    td:first-child{
                        color: $_255_186_85;
                        width: 85px;
                    }
                }
                tr:last-child{
                    td{
                        border-bottom: transparent solid 1px;
                    }
                }

            }
        }
        .right{
            flex: 1;
            height: 100%;
            .pcsbox{
                display: flex;
                justify-content: space-between;
                margin-top: 20px;
                .box{
                    height: 162px;
                    width: 270px;
                    .title{
                        height: 50px;
                        background-color: var(--pcsbox_bg);
                        color: $_191_191_191;
                        line-height: 42px;
                        text-align: center; font-size: 18px;

                        width: 100%;
                        box-sizing: border-box;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;
                    }
                    .value{
                        margin-top: 30px; font-size: 30px; text-align: center; color: $font_bright_blue;
                        span{ padding-left: 3px; font-size: 16px; color: $_191_191_191 }
                    }
                }
            }
            .huanjin{
                margin-top: 20px;
                height: 154px;
                display: flex;
                flex-direction: row;
                .huanjin_item{
                    flex: 1;
                    .huanjin_item_title{
                        height: 60px;
                        font-size: 16px;
                        color: $_191_191_191;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .huanjin_item_value{
                        height: 74px;
                        line-height: 74px;
                        border-right: $_128_128_128 solid 1px;
                        text-align: center;
                        color:$font_bright_blue;
                        font-size: 24px;
                        span{
                            font-size: 14px; color: $_191_191_191
                        }
                    }
                }

                .huanjin_item:last-child {
                    .huanjin_item_value {
                        border-right: transparent solid 1px;
                    }
                }
            }
            .status{
                margin-top: 20px;
                height: 274px;
                .pcs_status_table{
                    margin: 10px;
                    border-spacing: 0;
                    border-color: transparent;
                    td{
                        height: 80px;
                        border-right: $_89_89_89 dashed 1px;
                        border-bottom: rgb(67, 67, 67) dashed 1px;
                        width: 137px;
                        font-size: 16px;
                        .dot_title{
                            margin-top: -5px;
                            text-align: center;
                            color: $_191_191_191;
                        }
                        .dot{
                            width: 20px;
                            height: 20px;
                            background-color: $_89_89_89;
                            border-radius: 50%;
                            margin-left: 56px;
                            margin-top: 8px;
                        }
                        .dotGreen{
                            background-color: $_48_154_103;
                        }
                        .dotRed{
                            background-color: rgba(255, 0, 0, 1);
                        }
                        .dotBlue{
                            background-color: rgba(13, 198, 209, 1);
                        }
                        .dotYellow{
                            background-color: $_255_186_85
                        }
                    }
                    tr{
                        td:last-child{
                            border-right: transparent solid 1px;
                        }
                    }
                    tr:last-child{
                        td{
                            border-bottom: transparent solid 1px;
                        }
                    }
                }
            }

        }
        .boxBg{
            background-color: $_13_13_13;
            border: $_127_127_127 solid 1px;
        }

        .boxBg1{
            background-color: $_13_13_13;
            border: $_89_89_89 solid 1px;
        }
    }
</style>